import React, { useRef, useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Form, Input, Button, Row, Col, DatePicker, Select, message } from 'antd';
import { fetchDeliveryReceipts, searchDeliveryAPI } from 'services/delivery_receipts/delivery_receipts';
//sample data
import data from './delivery_sampleData';
import {fetchCustomersListAPI} from 'services/shared/fetchLovList';
//import { RegexInput } from 'shared_components/pattern_input';
import '../delivery.css'
import { AlphaNumInput } from 'shared_components/pattern_input';
import moment from 'moment';
import { UserAccessContext } from 'context/userAccess';


const { Text } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select;

function SearchForm({ onFinish, onSearchStart, onSearchEnd }) {
	const { userAccess } = useContext(UserAccessContext);
	const navigate = useHistory();
	const formRef = useRef();
	const [loading, setLoading] = useState(false);
	const [customerlist, setCustomersList] = useState([]);

	//sample data
	const [filterData, setFilterData] = useState(data);

	

	/*useEffect(() => {
        async function fetchData() {
            const customerslist = await fetchCustomersListAPI();
            
            setcustomerslist(customerslist);
        }
        fetchData();
    }, []);*/

	async function getLOVList(){
        try{
          
            const customers = await fetchCustomersListAPI();

           
            setCustomersList(customers);
        }catch(error) {
            console.log("error", error);
        }
    };

    useEffect( ()=> {
        function fetchData() {
            getLOVList();
        }
        setLoading(true);
        fetchData();
        setLoading(false);

    }, []);


	async function handleSubmit(formValues){
        // agent search api
        // console.log ("testformvalues", formValues)
        try {
            if (onSearchStart) onSearchStart();
            const result = await searchDeliveryAPI(formValues)
               
            //setFilterData(result);
            onFinish(result);
            
            if(result.length <= 0){
                message.info('No results found');
            }
        }catch(error) {
            console.log("error", error)
        } finally {
            if (onSearchEnd) onSearchEnd();
        }
    }

	const customersOptions = customerlist.map((item, index) => {
        return(
            <Option key={index} value={item.customer_id}>{item.customer}</Option>
        );
    })


	function handleFocusDr() {
		// @ts-ignore
		const { setFieldsValue } = formRef.current;
		setFieldsValue({ dr_date: [], customer: [] });
	}

	function handleFocusInput(){
        // @ts-ignore
        const { setFieldsValue } = formRef.current;
        setFieldsValue({ dr_no: '' })
    }

	function clearSearch() {
		// @ts-ignore
		const { setFieldsValue } = formRef.current;
		setFieldsValue({ dr_no: '', dr_date: [], customer: [] });
	}

	const handleDrDateOnChange = (date, dateString) => {
        // setDateFormat(dateString);
    }

	const disabledDate = (current) => {
        // Can not select future dates
        return current > moment().endOf('day');
    };

	return (
		<div>
			<Form layout="vertical" onFinish={handleSubmit} 
			ref={formRef} className='delivery-search-form'>
				{/* invoice fields */}
				<Row gutter={[8, 1]} justify="space-around">
					<Col className="gutter-row" span={6}>
						<Form.Item label="D.R NO." name="dr_no">
						<AlphaNumInput placeholder='DR NO.' 
                                className='dr-input-uppercase'
                                onFocus={handleFocusDr}
                                maxLength={50}
                            />
						</Form.Item>
					</Col>
					<Col span={1}>
                        <div style={{ marginLeft:5 ,marginRight:10, marginTop: 27 }}>
						{/* <div style={{ marginTop: 27 }}> */}
							<Text strong className="delivery-filler-str">
								OR
							</Text>
						</div>
					</Col>
					<Col className="gutter-row" span={5}>
						<Form.Item label="D.R DATE" name="dr_date">
							{/* <Input placeholder='INVOICE DATE'></Input> */}
							{/* @ts-ignore */}
							<RangePicker format={"MM-DD-YYYY"} onChange={handleDrDateOnChange}
							onFocus={handleFocusInput} 
							disabledDate={disabledDate} 
							/>
						</Form.Item>
					</Col>
					<Col className="gutter-row" span={12}>
						<Form.Item label="CUSTOMER" name="customer">
							<Select
								placeholder="CUSTOMER"
								showSearch	
                                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())} 
							    onFocus={handleFocusInput}
							>
								{customersOptions}
							</Select>
						</Form.Item>
					</Col>
				</Row>

				{/* buttons */}
				<Row gutter={[8, 1]} justify="end" align="bottom">
					<Col span={6} >
						<Form.Item shouldUpdate>
							{({ getFieldsValue }) => {
								const { dr_no, dr_date, customer } = getFieldsValue();
								// Allow search with any parameter, including when no date is specified (to show all dates)
								const disabled = !( dr_no || customer || 
									(dr_date && Array.isArray(dr_date) && dr_date.length > 0) );

								return (
									<div style={{ float: 'right' }}>
										<Button
											className="login-form-button inv-button"
											type="primary"
											htmlType="submit"
											disabled={disabled}
										>
											SEARCH
										</Button>
										<Button className="form-button inv-button-right" onClick={clearSearch}>
											CLEAR
										</Button>
									</div>
								);
							}}
						</Form.Item>
					</Col>
				</Row>
				{(userAccess['deliveryReceipt'].create === 'TRUE')
				?	<Row gutter={[8, 1]} justify="end" align="bottom">
						<Col className="gutter-row">
							<Form.Item>
								<Button
									// className="login-form-button inv-button-right"
									style={{ marginBottom: -5 }}
									type="primary"
									onClick={() => navigate.push('/delivery/data_entry')}
								>
									ADD DELIVERY RECEIPT
								</Button>
							</Form.Item>
						</Col>
					</Row>
				:	<></>
				}
			</Form>
		</div>
	);
}

export default SearchForm;
